import React, { FC, ReactNode, useCallback } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { TranslationKey, useTranslation } from '../translations';
import { captureError } from '../utils/errorHandling';
import { MaterialIcon } from './MaterialIcon';

interface CopyButtonProps {
  readonly children?: ReactNode;
  readonly textToCopy: string;
  readonly toastMessage?: TranslationKey;
  readonly color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'link'
    | ''
    | 'danger'
    | 'info'
    | 'warning';
}

export const CopyButton: FC<CopyButtonProps> = ({
  children,
  textToCopy,
  toastMessage = 'clipboard.copy.success',
  color = 'secondary',
}) => {
  const { ts } = useTranslation();

  const handleCopy = useCallback(() => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.info(ts(toastMessage));
      })
      .catch((error_) => {
        const error = error_ as Error;
        captureError(error);
        toast.warning(`${ts('clipboard.copy.error')} ${error.message}`);
      });
  }, [textToCopy, toastMessage, ts]);

  return (
    <Button
      color={color}
      onClick={handleCopy}
      outline
      title={ts('clipboard.copy.title')}
      type="button"
    >
      {children || <MaterialIcon name="content_copy" small />}
    </Button>
  );
};
